<template>
<div class="col-md-12">
    <div class="card">
        <div class="card-header">
            Master User
        </div>
        <div class="card-body">
            <v-data-table
                :headers="headers"
                :items="master_data"
                :search="search"
                item-key="id"
                class="elevation-1"
            >
                <template v-slot:top>

                    <v-btn
                        color="#FCC133"
                        dark
                        @click="newData"
                        >
                        New Data User
                    </v-btn>
                     <v-text-field
                          v-model="search"
                          append-icon="mdi-magnify"
                          label="Search Master User"
                          single-line
                          hide-details
                          color="#F9A825"
                        ></v-text-field>
                    <v-dialog
                        v-model="dialog"
                        persistent
                        max-width="50%"
                        >
                        
                        <v-card>
                            <v-card-title>
                            <span class="text-h5">Data User</span>
                            </v-card-title>
                            <v-card-text>
                                <div class="container">
                                    <div class="row">
                                        <v-text-field
                                        v-model="form.username"
                                        label="Username"
                                        color="#F9A825"
                                        required
                                        ></v-text-field>
                                    </div>
                                    <div class="row">
                                        <v-text-field
                                        v-model="form.password"
                                        label="Password"
                                        :type="show1 ? 'text' : 'password'"
                                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"

                                        required
                                        @click:append="show1 = !show1"
                                        color="#F9A825"
                                        ></v-text-field>
                                    </div>
                                    <div class="row">
                                        <v-text-field
                                        v-model="form.email"
                                        label="Email"
                                        color="#F9A825"
                                        required
                                        ></v-text-field>
                                    </div>
                                    <div class="row">
                                        <v-select
                                            :items="listRole"
                                            label="Role"
                                            required 
                                            item-text="DATA"
                                            item-value="ID"
                                            v-model="form.role"
                                            :rules="mandatoryRules"
                                            color="#F9A825"
                                            @change="checkRole"
                                        ></v-select>
                                    </div>
                                    <div class="row">
                                        <v-combobox
                                            :items="listKota"
                                            item-text="DESKRIPSI_DATA"
                                            item-value="ID_DATA"
                                            multiple
                                            chips
                                            :menu-props="{value:autoSelectMenu}"
                                            @click:append="toggle"
                                            v-model="form.data_kota"
                                            label="Registered City"
                                            color="#F9A825"
                                            :disabled="userRole"
                                        >
                                        </v-combobox>
                                    </div>

                                    <div class="row">
                                        <v-combobox
                                            :items="listKotaDom"
                                            item-text="DESKRIPSI_DATA"
                                            item-value="ID_DATA"
                                            multiple
                                            chips
                                            :menu-props="{value:autoSelectMenu2}"
                                            @click:append="toggle2"
                                            v-model="form.data_kota_dom"
                                            label="Hometown"
                                            color="#F9A825"
                                            :disabled="userRole2"
                                        >
                                        </v-combobox>
                                    </div>                       
                            
                                </div>
                            </v-card-text>
                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn style="margin-left:20px" v-show="!IfNew" color="#FCC133" @click="onResetPassword" dark>Reset Password</v-btn>
                            <v-btn style="margin-left:20px" color="#E12B38" dark @click="onClose">Cancel</v-btn>
                            <v-btn style="margin-left:20px;margin-right:10px" color="#3EB650" dark @click="onSubmit">Save</v-btn>

                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    
                    
                
                </template>
                
                <template v-slot:item.actions="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                    small
                    @click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon>
                </template>
            </v-data-table>
        </div>
    </div>
</div>

</template>

<script>
import axios from '@/axios'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
export default {
    data: () => ({
        dialog: false,
        headers: [
            { text: 'Username', value: 'name' , filterable: true},
            { text: 'Email',value: 'email' , filterable: true},
            { text: 'Role', value: 'role_name', filterable: true },
            { text: 'Created At', value: 'created_at' },
            { text: 'Actions', value: 'actions', sortable: false },
        ],
        listKota:[
            // {"DESKRIPSI_DATA":"BANDAR LAMPUNG","ID_DATA":48},
            // {"DESKRIPSI_DATA":"BANDUNG","ID_DATA":21}
        ],
        listKotaDom:[],
        show1:false,
        IfNew:true,
        master_data:[],
        form:{
            id:null,
            username: null,
            password: null,
            email: null,
            data_kota: [],
            data_kota_dom: [],
            role:null,
        },
        tmp_data_kota:[],
        autoSelectMenu:false,
        autoSelectMenu2:false,
        listRole:[
           {
                'ID': '1',
                'DATA': 'Admin' 
            },
            {
                'ID': '2',
                'DATA': 'Admin Tao Yu' 
            },
            {
                'ID': '3',
                'DATA': 'Admin Huang Yi' 
            },
            {
                'ID': '4',
                'DATA': 'Calon Tao Yu' 
            },
            {
                'ID': '5',
                'DATA': 'User Huang Yi' 
            },
            {
                'ID': '6',
                'DATA': 'Admin Domisili'
            },
            {
                'ID': '8',
                'DATA': 'Admin TaoYing Domisili'
            },
            {
                'ID': '10',
                'DATA': 'Admin Event'
            },
        ],
        mandatoryRules: [
            v => !!v || 'Data wajib di-isi',
        ],
        userRole:true,
        userRole2:true,
        search:''
    }),
    watch: {
        dialog (val) {
            val || this.onClose()
        },
    },
    mounted () {
        this.initialize();
    },
    beforeCreate: function () {
        if (!this.$session.exists()) {
        this.$router.push('/')
        }
    },
    methods: {
        toggle(){
            this.autoSelectMenu=!this.autoSelectMenu

        },
        toggle2(){
            this.autoSelectMenu2=!this.autoSelectMenu2

        },
        initialize () {
            // console.log('Dash '+this.$session.get('token'));
            this.master_data=[];
            this.listKota=[]
            axios({
                method: 'get',
                url: 'users',
                headers: {
                  Authorization: 'Bearer ' + this.$session.get('token'),
                },
            }).then(response => {
                if(response.data){
                    this.master_data=response.data;
                }
            }).catch(error=>{
                console.log('Error Fetch Data '+error);
            });

            axios({
                method: 'get',
                url: 'master_data',
                headers: {
                  Authorization: 'Bearer ' + this.$session.get('token'),
                },
            }).then(response => {
                // console.log('Kota '+response.data.Kota_Daftar);
                console.log(response.data);
                this.listKota=response.data.Kota_Daftar;
                this.tmp_data_kota=[]
            }).catch(error=>{
                 Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:error
                        });
            });

            axios({
                method: 'get',
                url: 'master_data',
                headers: {
                  Authorization: 'Bearer ' + this.$session.get('token'),
                },
            }).then(response => {
                // console.log('Kota '+response.data.Kota_Daftar);
                // console.log(response.data);
                this.listKotaDom=response.data.Kota_Domisili;
                this.tmp_data_kota=[]
            }).catch(error=>{
                 Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:error
                        });
            });
            
        },
        
        editItem (item) {//open modal
            this.IfNew=false;
            this.form.id=item.id
            //this.form.username=null;
            this.form.username=item.name
            this.form.email=item.email;
            this.form.role=item.role;
            console.log(item);
            // alert(this.form.role);
            // alert(item.list_kota);
            this.checkRole();
            if(item.list_kota || item.list_kota_dom){
                if(this.form.role === '6'){
                    this.form.data_kota_dom

                    let tmp3=[];
                    let data_kota_split2=item.list_kota_dom.split(',');
                    data_kota_split2.forEach(data => {
                        tmp3 = this.listKotaDom.find(item => item.ID_DATA === parseInt(data));
                        if(tmp3) this.form.data_kota_dom.push(tmp3);
                    });
                }else if(this.form.role === '8' || this.form.role === '10'){
                    this.form.data_kota

                    let tmp=[];
                    let data_kota_split=item.list_kota.split(',');
                    data_kota_split.forEach(data => {
                        tmp = this.listKota.find(item => item.ID_DATA === parseInt(data));
                        if(tmp) this.form.data_kota.push(tmp);
                    });

                    this.form.data_kota_dom

                    let tmp2=[];
                    let data_kota_split2=item.list_kota_dom.split(',');
                    data_kota_split2.forEach(data => {
                        tmp2 = this.listKotaDom.find(item => item.ID_DATA === parseInt(data));
                        if(tmp2) this.form.data_kota_dom.push(tmp2);
                    });
                }else{
                    this.form.data_kota

                    let tmp=[];
                    let data_kota_split=item.list_kota.split(',');
                    data_kota_split.forEach(data => {
                        tmp = this.listKota.find(item => item.ID_DATA === parseInt(data));
                        if(tmp) this.form.data_kota.push(tmp);
                    });
                }
                // if(this.form.role !== '6'){
                //     this.form.data_kota

                //     let tmp=[];
                //     let data_kota_split=item.list_kota.split(',');
                //     data_kota_split.forEach(data => {
                //         tmp = this.listKota.find(item => item.ID_DATA === parseInt(data));
                //         if(tmp) this.form.data_kota.push(tmp);
                //     });
                // }else{
                //     this.form.data_kota_dom

                //     let tmp2=[];
                //     let data_kota_split2=item.list_kota.split(',');
                //     console.log(data_kota_split2);
                //     data_kota_split2.forEach(data => {
                //         tmp2 = this.listKotaDom.find(item => item.ID_DATA === parseInt(data));
                //         if(tmp2) this.form.data_kota_dom.push(tmp2);
                //     });
                // }
            }
            // console.log(this.IfNew)
            this.dialog = true
        },
        deleteItem (item) {
            confirm('Are you sure you want to delete this item?') &&
            axios({
                method:'post',
                url:'delete_user',
                data:{
                    id: item.id
                },
                headers: {
                    'Authorization': 'Bearer '+this.$session.get('token')
                }
            }).then(response => {
                if(response){
                    this.initialize();
                     Swal.fire({
                                title:'Peringatan',
                                icon :'success',
                                text:response.data.message
                        });
                }
                // console.log(response);
            }).catch(error => {
                 Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:error.response
                        });
                // console.log(error.response);
            });
        },
        onSubmit () {
            var url='';
            if(this.IfNew) {
                url='register_user';
            }else if(this.form.id){
                url='update_user';               
            }
            if((this.form.username!==null && this.form.email!==null && this.form.password!==null && this.form.password.length>=8 && this.form.role!==null && this.IfNew===true) ||(this.form.username!==null && this.form.email!==null  && this.form.role!==null && this.form.id  ))
            {
                if(this.form.password!==null && this.form.password.length<8)
                {
                    Swal.fire({
                                title:'Peringatan',
                                icon :'info',
                                text:'Password minimal 8 karakter.'
                        });
                }
                if(this.form.role === '6'){
                    axios({
                        method:'post',
                        url:url,
                        data:{
                            id: this.form.id,
                            name: this.form.username,
                            password: this.form.password,
                            email: this.form.email,
                            role: this.form.role,
                            //data_kota: (this.form.data_kota),
                            data_kota: JSON.stringify(this.form.data_kota_dom),
                            user_id: this.$session.get('user_id'),
                            tipe:'dom'
                        },
                        headers: {
                            'Authorization': 'Bearer '+this.$session.get('token')
                        }
                    }).then(response => {
                        this.initialize();
                        this.dialog=false;
                         Swal.fire({
                                    title:'Peringatan',
                                    icon :'success',
                                    text:response.data.message
                            });
                        // console.log(response);
                    }).catch(error => {
                         Swal.fire({
                                    title:'Peringatan',
                                    icon :'error',
                                    text:'Data Duplikat'
                            });



                        // console.log(error.response);
                    });
                }else if (this.form.role === '8' || this.form.role ==='10'){
                    axios({
                        method:'post',
                        url:url,
                        data:{
                            id: this.form.id,
                            name: this.form.username,
                            password: this.form.password,
                            email: this.form.email,
                            role: this.form.role,
                            //data_kota: (this.form.data_kota),
                            data_kota_dom: JSON.stringify(this.form.data_kota_dom),
                            data_kota: JSON.stringify(this.form.data_kota),
                            user_id: this.$session.get('user_id'),
                            tipe:'taodom'
                        },
                        headers: {
                            'Authorization': 'Bearer '+this.$session.get('token')
                        }
                    }).then(response => {
                        this.initialize();
                        this.dialog=false;
                         Swal.fire({
                                    title:'Peringatan',
                                    icon :'success',
                                    text:response.data.message
                            });
                        // console.log(response);
                    }).catch(error => {
                         Swal.fire({
                                    title:'Peringatan',
                                    icon :'error',
                                    text:'Data Duplikat'
                            });



                        // console.log(error.response);
                    });
                }
                else{
                    axios({
                        method:'post',
                        url:url,
                        data:{
                            id: this.form.id,
                            name: this.form.username,
                            password: this.form.password,
                            email: this.form.email,
                            role: this.form.role,
                            //data_kota: (this.form.data_kota),
                            data_kota: JSON.stringify(this.form.data_kota),
                            user_id: this.$session.get('user_id'),
                            tipe:'nondom'
                        },
                        headers: {
                            'Authorization': 'Bearer '+this.$session.get('token')
                        }
                    }).then(response => {
                        this.initialize();
                        this.dialog=false;
                         Swal.fire({
                                    title:'Peringatan',
                                    icon :'success',
                                    text:response.data.message
                            });
                        // console.log(response);
                    }).catch(error => {
                         Swal.fire({
                                    title:'Peringatan',
                                    icon :'error',
                                    text:'Data Duplikat'
                            });



                        // console.log(error.response);
                    });
                }
                // if(this.form.role !== '6'){
                //     axios({
                //         method:'post',
                //         url:url,
                //         data:{
                //             id: this.form.id,
                //             name: this.form.username,
                //             password: this.form.password,
                //             email: this.form.email,
                //             role: this.form.role,
                //             //data_kota: (this.form.data_kota),
                //             data_kota: JSON.stringify(this.form.data_kota),
                //             user_id: this.$session.get('user_id')
                //         },
                //         headers: {
                //             'Authorization': 'Bearer '+this.$session.get('token')
                //         }
                //     }).then(response => {
                //         this.initialize();
                //         this.dialog=false;
                //          Swal.fire({
                //                     title:'Peringatan',
                //                     icon :'success',
                //                     text:response.data.message
                //             });
                //         // console.log(response);
                //     }).catch(error => {
                //          Swal.fire({
                //                     title:'Peringatan',
                //                     icon :'error',
                //                     text:'Data Duplikat'
                //             });



                //         // console.log(error.response);
                //     });
                // }else {
                //     axios({
                //         method:'post',
                //         url:url,
                //         data:{
                //             id: this.form.id,
                //             name: this.form.username,
                //             password: this.form.password,
                //             email: this.form.email,
                //             role: this.form.role,
                //             //data_kota: (this.form.data_kota),
                //             data_kota: JSON.stringify(this.form.data_kota_dom),
                //             user_id: this.$session.get('user_id')
                //         },
                //         headers: {
                //             'Authorization': 'Bearer '+this.$session.get('token')
                //         }
                //     }).then(response => {
                //         this.initialize();
                //         this.dialog=false;
                //          Swal.fire({
                //                     title:'Peringatan',
                //                     icon :'success',
                //                     text:response.data.message
                //             });
                //         // console.log(response);
                //     }).catch(error => {
                //          Swal.fire({
                //                     title:'Peringatan',
                //                     icon :'error',
                //                     text:'Data Duplikat'
                //             });



                //         // console.log(error.response);
                //     });
                // }     
            }else{
                if(this.form.password.length<8)
                {
                    Swal.fire({
                                title:'Peringatan',
                                icon :'info',
                                text:'Password minimal 8 karakter.'
                        });
                }else{
                    // console.log(this.form.username)
                    // console.log(this.form.email)
                    // console.log(this.form.password)
                    // console.log(this.form.role)
                    // console.log(this.ifNew)
                    // console.log(this.form.id)
                     Swal.fire({
                                title:'Peringatan',
                                icon :'info',
                                text:'Harap isi kolom yang kosong'
                        });
                }
                
            }
            
            // this.IfNew=false;
            // this.close()
        },
        newData(){
            this.reset();
            this.ifNew=true;
            this.dialog=true;
        },
        reset(){
            this.form.id=null;
            this.form.username=null;
            this.form.password=null;
            this.form.email=null;
            this.form.role=null;
            this.form.data_kota=[];
            this.form.data_kota_dom=[];

        },
        onClose(){
            this.reset();
            this.dialog = false;
        },
        onResetPassword(){
            
           // alert(this.form.id)
            if(this.form.id){
                confirm('Are you sure to reset password for this user?') &&
                axios({
                    method: 'post',
                    url: 'reset_password',
                    data: {
                      id: this.form.id,
                    },
                    headers: {
                      Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                    if(response.data){
                        prompt("Copy this password to clipboard: Ctrl+C", response.data);
                        // alert(response.data);
                        this.initialize();
                        this.dialog=false;
                    }
                    console.log(response);
                }).catch(error => {
                    console.log(error.response);
                });
            }else{
                 Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:"Reset Password Can't be done. Please refresh the page"
                        });
            }
        },
        checkRole(){
            if(this.form.role=='4' || this.form.role=='5' || this.form.role == '9'){
                this.userRole=true;
                this.userRole2=true;
            } else if(this.form.role == '6'){
                this.userRole=true;
                this.userRole2=false;
                this.form.data_kota=[];
            } else if(this.form.role == '8'){
                this.userRole = false;
                this.userRole2 = false;
            } else if (this.form.role == '10'){
                this.userRole = true;
                this.userRole2 = false;
            }
            else{
                this.form.data_kota_dom=[];
                this.userRole=false;
                this.userRole2=true;
            }
        },
    },
    components: {
    },
}
</script>